import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import "./ProtectedRoute.css";

const ProtectedRoute = ({
  children,
  allowedDepartments = [],
  allowedRoles = ["HR", "admin", "employee"],
  fallbackPath = "/HR/dashboard",
}) => {
  const { user, loading } = useSelector((state) => state.currentUser);

  // Show loading if user data is still being fetched
  if (loading || !user) {
    return (
      <div className="access-denied">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // Check if user is authenticated
  if (!user?.user) {
    return <Navigate to="/" replace />;
  }

  // Determine fallback path based on user role
  const getFallbackPath = () => {
    if (user?.user?.role === "employee") {
      return "/employee/dashboard";
    }
    return fallbackPath;
  };

  // Check if user has access based on department and role
  const hasDepartmentAccess = allowedDepartments.includes(
    user?.user?.department?._id.toString()
  );

  const hasRoleAccess = allowedRoles.includes(user?.user?.role);
  const hasAccess = hasDepartmentAccess && hasRoleAccess;

  if (!hasAccess) {
    return <Navigate to={getFallbackPath()} replace />;
  }

  return children;
};

export default ProtectedRoute;
